<script setup>
  import { ref, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useIntegrationsStore } from "@/stores/integrations";
  import useEncryption from "@/utils/helpers/encryption";

  const uiStore = useUiStore();
  const integrationsStore = useIntegrationsStore();
  const { encryptionPassword } = useEncryption();
  const emit = defineEmits(['openStoresModalAfterValidateToken']);
  const company_id = useCompanyStore().companyId;
  const token = ref(null);
  const encryptedToken = ref(null);
  let isSubmitted = ref(false);
  const getModalAction = computed(() => uiStore.modalAction);

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  const onSubmit = async () => {
    isSubmitted.value = true;
    encryptedToken.value = await encryptionPassword(token.value);
    const data = { 
      token : encryptedToken.value,
      company_id 
    };
    integrationsStore.addStoreVensafeByToken(data).then((res) => {
      res.encryptedToken = encryptedToken.value;
      emit('openStoresModalAfterValidateToken', res);
      resetStoreData();
    }).catch(() => {
      isSubmitted.value = false;
    });
  }
</script>
<template>
  <DModal v-if="getModalAction === 'add_store_by_token'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add Your Token </template>
    
    <template #body>

      <DInput :value="token" @input="token = $event.target.value" label="Token" width="100%" />

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!token || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Submit 
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
